import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e772d6ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-section" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  slot: "heading",
  id: "header-headline",
  class: "pvd-title__heading pvd-title__heading--level-1"
}
const _hoisted_4 = {
  slot: "subheading",
  id: "header-teaser",
  class: "pvd-title__heading pvd-title__heading--level-2"
}
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = { class: "save-section" }
const _hoisted_8 = { id: "slider-component-section" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", {
  id: "slider-title",
  slot: "heading",
  class: "pvd-title__heading pvd-title__heading--level-2"
}, " Lock in the best rate for you ", -1))
const _hoisted_10 = { id: "education-page-slider-component" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = { id: "get-this-rate-button" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = {
  key: 0,
  id: "timestamp-message",
  class: "pvd3-microcopy-root"
}
const _hoisted_15 = { class: "pvd-microcopy__microcopy" }
const _hoisted_16 = { class: "save-section-info" }
const _hoisted_17 = {
  id: "save-section-title",
  slot: "heading",
  class: "pvd-title__heading pvd-title__heading--level-2"
}
const _hoisted_18 = { id: "save-section-text" }
const _hoisted_19 = { class: "fcd-icons-section" }
const _hoisted_20 = { id: "fcd-icons-title" }
const _hoisted_21 = { class: "fcd-icons-list" }
const _hoisted_22 = ["innerHTML"]
const _hoisted_23 = { class: "risk-benefit-section" }
const _hoisted_24 = { class: "learn-more-subsection" }
const _hoisted_25 = { id: "learn-more-heading" }
const _hoisted_26 = { class: "pvd3-tile-root" }
const _hoisted_27 = { class: "pvd-tile__tile" }
const _hoisted_28 = { class: "pvd-tile__content" }
const _hoisted_29 = {
  slot: "heading",
  class: "pvd-expand-collapse__heading",
  "data-cy": "benefits-heading"
}
const _hoisted_30 = ["innerHTML"]
const _hoisted_31 = { class: "pvd3-tile-root" }
const _hoisted_32 = { class: "pvd-tile__tile" }
const _hoisted_33 = { class: "pvd-tile__content" }
const _hoisted_34 = {
  slot: "heading",
  class: "pvd-expand-collapse__heading",
  "data-cy": "risks-heading"
}
const _hoisted_35 = ["innerHTML"]
const _hoisted_36 = { class: "faq-section" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", {
  slot: "heading",
  class: "pvd-title__heading pvd-title__heading--level-3",
  "data-cy": "faq-title"
}, "FAQs", -1))
const _hoisted_38 = { class: "faq-list" }
const _hoisted_39 = { class: "faq-list-item" }
const _hoisted_40 = ["innerHTML"]
const _hoisted_41 = ["innerHTML"]
const _hoisted_42 = { class: "additional-links-section" }
const _hoisted_43 = { id: "additional-links-title" }
const _hoisted_44 = { class: "additional-links-list" }
const _hoisted_45 = ["innerHTML"]
const _hoisted_46 = { class: "additional-links-button" }
const _hoisted_47 = { class: "additional-links-button" }
const _hoisted_48 = { class: "disclosures-section" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_pvd3_title = _resolveComponent("pvd3-title")!
  const _component_fractional_cd_slider = _resolveComponent("fractional-cd-slider")!
  const _component_pvd3_inline_alert = _resolveComponent("pvd3-inline-alert")!
  const _component_pvd3_button = _resolveComponent("pvd3-button")!
  const _component_InputModal = _resolveComponent("InputModal")!
  const _component_pvd3_link = _resolveComponent("pvd3-link")!
  const _component_pvd3_expand_collapse = _resolveComponent("pvd3-expand-collapse")!
  const _component_pvd3_microcopy = _resolveComponent("pvd3-microcopy")!
  const _component_pvd3_footnote = _resolveComponent("pvd3-footnote")!
  const _component_pvd3_footnotes = _resolveComponent("pvd3-footnotes")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        id: "header-background",
        src: _ctx.headerBackground,
        alt: "gradient background"
      }, null, 8, _hoisted_2),
      _createVNode(_component_pvd3_title, { id: "header-title" }, {
        default: _withCtx(() => [
          _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.header.headline), 1),
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.header.teaser), 1),
          _createElementVNode("span", {
            slot: "subheading",
            id: "header-subtext",
            innerHTML: _ctx.headerSubtext
          }, null, 8, _hoisted_5)
        ]),
        _: 1
      })
    ]),
    _hoisted_6,
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_fractional_cd_slider, {
            id: `apy-slider`,
            values: _ctx.apyValuesList,
            currentValue: _ctx.sliderIndex,
            labelSize: `large`,
            onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.sliderChanged($event)))
          }, null, 8, ["values", "currentValue"]),
          (_ctx.store.offeringsError)
            ? (_openBlock(), _createBlock(_component_pvd3_inline_alert, {
                key: 0,
                id: "offerings-alert"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.clientConstants.OFFERINGS_UNAVAILABLE_ERROR), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_pvd3_button, {
            id: "amount-modal-trigger",
            "pvd-trigger": "",
            "pvd-disabled": this.store.offeringsError,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openInputModal())),
            ref: "amount-modal-trigger"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.clientConstants.GET_THIS_RATE_BUTTON_TEXT), 1)
            ]),
            _: 1
          }, 8, ["pvd-disabled"]),
          _createVNode(_component_InputModal, {
            id: "input-modal",
            ref: "inputModal",
            sliderIndex: _ctx.sliderIndex,
            onModalClosed: _cache[2] || (_cache[2] = ($event: any) => (_ctx.closeInputModal($event)))
          }, null, 8, ["sliderIndex"])
        ]),
        _hoisted_13,
        (this.store.offeringsLoaded)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.timestampMessage), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("h2", _hoisted_17, _toDisplayString(_ctx.saveOnYourTermsHeadline), 1),
        _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.saveOnYourTermsText), 1),
        _createVNode(_component_pvd3_link, {
          id: "save-info-link",
          "data-cy": "view-all-cds",
          innerHTML: _ctx.saveOnYourTermsLink
        }, null, 8, ["innerHTML"])
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("h2", _hoisted_20, _toDisplayString(_ctx.fcdTitle.headline), 1),
      _createElementVNode("ul", _hoisted_21, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fcdImages, (icon) => {
          return (_openBlock(), _createElementBlock("li", {
            key: icon.index
          }, [
            _createElementVNode("span", { innerHTML: icon }, null, 8, _hoisted_22)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("h2", _hoisted_25, _toDisplayString(_ctx.learnMoreText), 1),
        _createVNode(_component_pvd3_link, {
          id: "learn-more-url",
          innerHTML: _ctx.learnMoreUrl
        }, null, 8, ["innerHTML"])
      ]),
      _createElementVNode("section", _hoisted_26, [
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _createVNode(_component_pvd3_expand_collapse, { "pvd-size": "large" }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.benefits.subHeadline), 1),
                _createElementVNode("div", {
                  class: "pvd-expand-collapse__content",
                  innerHTML: _ctx.benefits.text,
                  "data-cy": "benefits-text"
                }, null, 8, _hoisted_30)
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_31, [
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            _createVNode(_component_pvd3_expand_collapse, { "pvd-size": "large" }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.risks.subHeadline), 1),
                _createElementVNode("div", {
                  class: "pvd-expand-collapse__content",
                  innerHTML: _ctx.risks.text,
                  "data-cy": "risks-text"
                }, null, 8, _hoisted_35)
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_36, [
      _createVNode(_component_pvd3_title, null, {
        default: _withCtx(() => [
          _hoisted_37
        ]),
        _: 1
      }),
      _createElementVNode("ul", _hoisted_38, [
        _createElementVNode("li", _hoisted_39, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.faqList, (faq) => {
            return (_openBlock(), _createBlock(_component_pvd3_expand_collapse, {
              "pvd-size": "medium",
              key: faq.index
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", {
                  slot: "heading",
                  class: "pvd-expand-collapse__heading",
                  innerHTML: _ctx.updateTooltip(faq.question)
                }, null, 8, _hoisted_40),
                _createElementVNode("div", {
                  class: "pvd-expand-collapse__content",
                  innerHTML: _ctx.updateTooltip(faq.text)
                }, null, 8, _hoisted_41)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_42, [
      _createElementVNode("h2", _hoisted_43, _toDisplayString(_ctx.resources.keyTakeaways), 1),
      _createElementVNode("ul", _hoisted_44, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.additionalLinks, (link) => {
          return (_openBlock(), _createElementBlock("li", {
            key: link.index
          }, [
            _createElementVNode("span", { innerHTML: link }, null, 8, _hoisted_45)
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_46, [
        _createVNode(_component_pvd3_button, {
          "pvd-id": "additional-links-cd-button",
          "pvd-href": _ctx.cdLaddersUrl
        }, {
          default: _withCtx(() => [
            _createTextVNode("Get started buying a CD")
          ]),
          _: 1
        }, 8, ["pvd-href"])
      ]),
      _createElementVNode("div", _hoisted_47, [
        _createVNode(_component_pvd3_button, {
          "pvd-variant": "secondary",
          "pvd-id": "additional-links-account-button",
          "pvd-href": _ctx.clientConstants.OPEN_ACCOUNT_URL
        }, {
          default: _withCtx(() => [
            _createTextVNode("Open an account")
          ]),
          _: 1
        }, 8, ["pvd-href"])
      ])
    ]),
    _createElementVNode("div", _hoisted_48, [
      _hoisted_49,
      _createVNode(_component_pvd3_footnotes, null, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.disclosures, (disclosure) => {
            return (_openBlock(), _createBlock(_component_pvd3_footnote, {
              key: disclosure.text
            }, {
              default: _withCtx(() => [
                _createVNode(_component_pvd3_microcopy, {
                  innerHTML: disclosure.text,
                  "data-cy": "disclosure"
                }, null, 8, ["innerHTML"]),
                _hoisted_50
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      })
    ])
  ]))
}